<div class="modal-container main-font">
  <div class="modal-content-container">
    <div class="modal-header-container">
      <div class="title-container permission-modal-header-title">
        <p class="modal-title mb-0 permission-modal-title">
          {{ edit ? 'Modifica' : 'Nuova' }} richiesta di permesso
        </p>
      </div>
    </div>

    <div class="modal-content">
      <form
        *ngIf="requestForm"
        class="form-container permission-form"
        [formGroup]="requestForm">
        <div
          class="permission-steps-bar"
          *ngIf="!edit && newRequestControls.length > 0">
          <div class="permission-steps-info">
            <span class="permission-steps-text"
              >Step {{ currentStep + 1 }} di {{ totalSteps }}</span
            >
            <div class="permission-steps-dots">
              <span
                *ngFor="let dot of stepDots; trackBy: trackByNumber"
                class="permission-step-dot"
                [class.active]="dot === currentStep"></span>
            </div>
          </div>

          <div class="permission-steps-nav">
            <button
              type="button"
              class="permission-nav-btn"
              [disabled]="currentStep === 0"
              (click)="prevStep()"
              aria-label="Step precedente">
              <img
                src="assets/images/Shared/material-symbols-light_arrow-back.svg"
                alt=""
                class="permission-nav-icon" />
            </button>
            <button
              type="button"
              class="permission-nav-btn"
              [disabled]="currentStep === totalSteps - 1"
              (click)="nextStep()"
              aria-label="Step successivo">
              <img
                src="assets/images/Shared/material-symbols-light_arrow-right.svg"
                alt=""
                class="permission-nav-icon" />
            </button>
          </div>
        </div>

        <div class="permission-rows" formArrayName="dataArray">
          <ng-container
            *ngFor="
              let item of visibleRequests;
              trackBy: trackByVisibleRequest
            ">
            <div [class.permission-row-card]="!edit">
              <div class="permission-row-card-header" *ngIf="!edit">
                <p class="permission-row-card-title mb-0">
                  Richiesta {{ item.index + 1 }}
                </p>
                <button
                  type="button"
                  [disabled]="newRequestControls.length === 1"
                  class="permission-delete-link"
                  (click)="deleteRequest(item.control)">
                  <img
                    src="assets/images/Shared/delete_red.svg"
                    class="icon-delete-request" />
                  <span class="permission-delete-text">Elimina</span>
                </button>
              </div>

              <div class="permission-row" [formGroupName]="item.index">
                <div
                  class="permission-blocking-alert"
                  *ngIf="hasBlockingConflict(item.index)">
                  <div class="permission-blocking-alert-content">
                    <img
                      src="assets/images/Shared/info_alert_blue_24.svg"
                      alt=""
                      class="permission-blocking-alert-icon" />
                    <p class="permission-blocking-alert-text mb-0">
                      {{ getExistingEventsAlertText(item.index) }}
                    </p>
                  </div>
                </div>

                <div
                  class="existing-events-alert"
                  *ngIf="
                    getExistingEventsForRequest(item.index).length > 0 &&
                    !hasBlockingConflict(item.index)
                  ">
                  <p class="existing-events-alert-title mb-0">
                    Eventi già presenti nella giornata
                  </p>
                  <p class="existing-events-alert-text mb-0">
                    {{ getExistingEventsAlertText(item.index) }}
                  </p>
                </div>

                <div class="permission-row-grid">
                  <div class="permission-field permission-field-day">
                    <label class="permission-label">Data</label>
                    <nz-date-picker
                      class="permission-picker"
                      [nzDisabled]="edit"
                      nzFormat="dd/MM/yyyy"
                      [nzPlaceHolder]="'Seleziona giorno'"
                      formControlName="date"
                      [nzDisabledDate]="disablePastAndWeekendDates"
                      (ngModelChange)="
                        onDateChange(item.index)
                      "></nz-date-picker>
                  </div>

                  <div class="permission-field">
                    <label class="permission-label">Ora di inizio</label>
                    <nz-time-picker
                      class="permission-picker"
                      [nzDefaultOpenValue]="getDefaultStartTime(item.index)"
                      [nzDisabledHours]="disabledHoursStart(item.index)"
                      (nzOpenChange)="onOpenTimePicker($event)"
                      [nzHideDisabledOptions]="false"
                      (ngModelChange)="onChangeTime(item.index)"
                      [nzDisabledMinutes]="disabledMinutesStart(item.index)"
                      nzFormat="HH:mm"
                      [nzMinuteStep]="15"
                      [nzDefaultOpenValue]="defaultTime"
                      [nzNowText]="' '"
                      [nzPlaceHolder]="'Orario'"
                      [nzDisabled]="
                        hasBlockingConflict(item.index) ||
                        !item.control.get('date')?.value
                      "
                      formControlName="startTime"></nz-time-picker>
                  </div>

                  <div class="permission-field">
                    <label class="permission-label">Ora di fine</label>
                    <nz-time-picker
                      class="permission-picker"
                      [ngClass]="{
                        'is-invalid':
                          (item.control.get('endTime')?.invalid ||
                            item.control.errors?.['minDuration']) &&
                          (item.control.touched || item.control.dirty)
                      }"
                      nzFormat="HH:mm"
                      [nzDefaultOpenValue]="getDefaultEndTime(item.index)"
                      [nzDisabledMinutes]="disabledMinutesEnd(item.index)"
                      [nzHideDisabledOptions]="false"
                      [nzDisabledHours]="disabledHoursEnd(item.index)"
                      (ngModelChange)="onChangeEndTime(item.index)"
                      [nzDefaultOpenValue]="defaultTime"
                      [nzDisabled]="
                        hasBlockingConflict(item.index) ||
                        !item.control.get('date')?.value ||
                        !item.control.get('startTime')?.value
                      "
                      [nzMinuteStep]="15"
                      [nzNowText]="' '"
                      [nzPlaceHolder]="'Orario'"
                      formControlName="endTime"></nz-time-picker>
                  </div>
                </div>

                <div class="permission-errors row">
                  <div
                    *ngIf="
                      item.control.errors?.['overlap'] &&
                      (item.control.touched || item.control.dirty)
                    "
                    class="text-danger col-12">
                    La fascia oraria si sovrappone a un'altra richiesta dello
                    stesso giorno.
                  </div>

                  <div
                    *ngIf="
                      item.control.errors?.['duplicate'] &&
                      (item.control.touched || item.control.dirty)
                    "
                    class="text-danger col-12">
                    Esiste già una richiesta per questo giorno con lo stesso
                    orario.
                  </div>

                  <div
                    *ngIf="
                      item.control.errors?.['minDuration'] &&
                      (item.control.touched || item.control.dirty)
                    "
                    class="text-danger col-12">
                    La durata minima è di 30 minuti.
                  </div>
                </div>

                <div
                  class="note-container permission-note-container permission-row-note">
                  <p class="m-0 p-0 text-note permission-label">Nota</p>
                  <div class="permission-note-wrapper">
                    <textarea
                      class="w-100 permission-note-textarea"
                      [nzAutosize]="{ minRows: 5, maxRows: 5 }"
                      formControlName="notes"
                      [readOnly]="hasBlockingConflict(item.index)"
                      nz-input
                      maxlength="250"
                      (input)="limitTextLength(item.index)"
                      placeholder="Scrivi il corpo dell'email per la richiesta di permesso">
                    </textarea>
                    <span class="permission-note-counter">
                      {{ (item.control.get('notes')?.value || '').length }}/250
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>

        <button
          *ngIf="!edit"
          type="button"
          class="permission-add-btn"
          (click)="addRequest()">
          <span class="permission-add-icon">+</span>
          Aggiungi richiesta
        </button>
      </form>
    </div>
    <div class="modal-footer-container">
      <button
        type="button"
        class="primary-btn-outline-new w-100 permission-footer-btn"
        (click)="closeModal()">
        Annulla
      </button>
      <button
        type="button"
        class="primary-btn-new w-100 permission-footer-btn"
        [disabled]="requestForm.invalid || hasBlockingConflicts"
        (click)="edit ? updateRequest() : saveRequestPermission()">
        {{ edit ? 'Salva' : 'Invia' }}
      </button>
    </div>
  </div>
</div>
